import { createFileRoute } from '@tanstack/react-router'
import ProjectBoardPage from '@/spa/pages/projects/ProjectBoardPage'
import { routeErrorComponent } from '../../_shared/RouteError'

export const Route = createFileRoute('/projects/$id/board')({
  component: ProjectBoardPage,
  errorComponent: routeErrorComponent,
})
